import * as yup from 'yup';
import { changeRuleNameValidation } from '../../validation/changeRuleNameValidation';
import { uniqueArray } from '../../validation/uniqueArray';

const fbAccId = yup
  .string()
  .transform((v) => String(v))
  // numbers only
  .matches(/^\d+$/, 'Only numbers are allowed')
  .trim();
// .length(16, 'Account id must be exactly 16 chars');
export const fbAccIdArray = yup
  .array()
  .of(fbAccId)
  .min(1)
  .test('uniqueArray', 'Only unique account ids are allowed', uniqueArray);

const ruleEditSchema = yup.object().shape({
  name: yup
    .string()
    .required()
    .min(1)
    .label("Can't be empty")
    .when('$duplicateMode', {
      is: (val: boolean) => val,
      then: (schema) =>
        // @ts-expect-error type correction
        schema.test('uniqueRule', 'You have to change rule name for duplicating', changeRuleNameValidation),
      otherwise: (schema) => schema,
    }),
  project: yup.number().required().label('project').positive('Please select project'),
  flows: yup.array().of(yup.number()).label('flow'),
  level: yup.string().required().oneOf(['adset', 'ad', 'campaign']).label('level'),
  groupId: yup.string().label('rule group'),
  description: yup.string(),
  notificationChannels: yup.array().default([]),
  notificationLevel: yup.string(),
  notificationMessage: yup
    .object()
    .shape({
      title: yup.string().nullable(),
      body: yup.string().nullable(),
    })
    .nullable(),
  facebookAdAccountIds: fbAccIdArray,
  ruleStatus: yup.string().required().oneOf(['paused', 'archived', 'active']),
  networkId: yup.number(),
  actionTypesIds: yup.array(yup.number()),
  mode: yup.string().oneOf(['edit', 'duplicate', 'read']),
});

export default ruleEditSchema;
